import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatAccounts = async (addressId) => {
  return await request.get(
    `/HousingStock/address/${addressId}/accounts`,
    {},
    'При загрузке лицевых счетов произошла ошибка',
    []
  );
};

const useFlatAccounts = (addressId, options = {}) =>
  useQuery(
    getQueryKeys.flatAccounts(addressId),
    () => getFlatAccounts(addressId),
    {
      placeholderData: [],
      enabled: Boolean(addressId),
      ...options,
    }
  );

export default useFlatAccounts;
